import { ReactNode } from 'react';

import { ACCENT_LIGHT } from './constants';

export const ProfessionIcon = ({
  children,
  bg = ACCENT_LIGHT,
}: {
  children: ReactNode;
  bg?: string;
}) => (
  <div
    style={{
      width: 64,
      height: 64,
      borderRadius: '50%',
      backgroundColor: bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 12px',
    }}
  >
    {children}
  </div>
);
